import { coreColors } from '../../../../../styles/shared/variables';

export const desktopStandardDropdownStyle = {
    width: '500px',
    textAlign: 'center'
}

export const desktopStandardDropdownMenuItemStyle = {
    fontSize: '18px',
    color: coreColors.blue300
}


// WEBPACK FOOTER //
// ./src/components/common/dropdowns/standard/styles/desktop.js